import * as yup from 'yup';

export const editCustomerSchema = yup.object({
	name: yup
		.string()
		.required('Please enter customer name!'),
	email: yup
		.string()
		.email('Invalid email')
		.required('Please enter your email!'),
	isSeller: yup
		.boolean()
		.required('Please enter your email!'),
	sellerName: yup
		.string()
		.required('Please enter seller name!'),
	sellerDescription: yup
		.string()
		.required('Please enter customer description!'),
	rating: yup
		.number(),
	numReviews: yup
		.number()
});
